// Add GA clientId to all request to download game client
$(document).ready(() => {
    setTimeout(() => {
        if (typeof ga === 'undefined') return
        ga(tracker => {
            $('[data-analytics-track]').each(function () {
                if ($(this).data('analytics-track') === 'clientId') {
                    var href = $(this).attr('href')
                    var clientId = tracker.get('clientId')

                    $(this).attr('href', `${href}&id=${clientId}`)
                }
            })
        })
    }, 280) // Wait for the GA method to load
})
